import { Heart } from "../../../../core/icons/Heart";
import { XClose2 } from "../../../../core/icons/XClose";

export const ButtonLikeDislike = ({ handleLikeMatch, rippleLike, rippleDislike }: { handleLikeMatch: (type: "like" | "dislike") => void; rippleLike: boolean; rippleDislike: boolean }) => {
	return (
		<>
			<button
				className="relative flex justify-center items-center w-14 h-14 max-md:w-16 max-md:h-16 bg-white text-[#FF2C2C] shadow-[0px_0px_20px_5px_rgba(0,0,0,0.1)] rounded-full"
				onClick={() => handleLikeMatch("dislike")}
				disabled={rippleLike || rippleDislike}
			>
				{rippleDislike && <span className="-z-10 absolute inline-flex h-12 w-12 max-md:h-14 max-md:w-14 animate-[ping_500ms_cubic-bezier(0,0,0.2,1)_infinite] rounded-full bg-graySecondary" />}
				<XClose2 className={`z-10 transition-transform duration-300 ${rippleDislike ? "scale-125" : "scale-100"}`} />
			</button>
			<button
				className="relative flex justify-center items-center w-14 h-14 max-md:w-16 max-md:h-16 bg-primary shadow-[0px_0px_20px_5px_rgba(0,0,0,0.1)] rounded-full"
				onClick={() => handleLikeMatch("like")}
				disabled={rippleLike || rippleDislike}
			>
				{rippleLike && <span className="-z-10 absolute inline-flex h-12 w-12 max-md:h-14 max-md:w-14 animate-[ping_500ms_cubic-bezier(0,0,0.2,1)_infinite] rounded-full bg-primary" />}
				<Heart className={`z-10 transition-transform duration-300 ${rippleLike ? "scale-125" : "scale-100"}`}/>
			</button>
		</>
	);
};
